import type { MerchantProfileView } from '../api.js';

/** Factual saved-snapshot dates, never a claim that the account is current/live. */
export function sourceObservationText(
  observation: MerchantProfileView['sourceObservation'],
  language: 'en' | 'ar',
): string | null {
  if (!observation) return null;
  const collected = Date.parse(observation.collectedAt);
  if (!Number.isFinite(collected) || collected <= 0 || collected > Date.now())
    return null;
  const format = new Intl.DateTimeFormat(
    language === 'ar' ? 'ar-SA-u-ca-gregory-nu-latn' : 'en-GB',
    {
      dateStyle: 'medium',
      timeStyle: 'short',
      timeZone: 'UTC',
    },
  );
  const collection = format.format(collected);
  const cached =
    observation.oldestCachedAt === null ? NaN : Date.parse(observation.oldestCachedAt);
  const cache =
    Number.isFinite(cached) && cached > 0 && cached <= collected
      ? format.format(cached)
      : null;
  return language === 'ar'
    ? `جُمعت المعلومات في ${collection} (UTC).${cache === null ? '' : ` تشمل معلومات مخزنة مؤقتًا منذ ${cache} (UTC).`}`
    : `Collected on ${collection} (UTC).${cache === null ? '' : ` Includes cached evidence from ${cache} (UTC).`}`;
}
